import type { ReactNode } from 'react'
import { defineMessages, useIntl } from 'react-intl'

import ExperiencesHomepageBrowseTileCarousel from './ExperiencesHomepageBrowseTileCarousel'
import useExperiencesHomepageDiscoverNearData from 'components/Experiences/hooks/useExperiencesHomepageDiscoverNearData'

const messages = defineMessages({
  sectionTitle: {
    id: 'vaByXmj2cw7dei5LT8uj',
    defaultMessage: 'Discover near <i>{placeName}</i>',
    description: 'Section heading for the Discover Near destination carousel on the Experiences homepage uplift',
  },
  viewOffers: {
    id: '-mrapk1I1Sq-jGqYgDRI',
    defaultMessage: 'View {count, plural, one {# offer} other {# offers}}',
    description: 'Tertiary call-to-action beside the Discover Near carousel linking to all experiences for the anchor city',
  },
})

const DISCOVER_NEAR_TRACKING = { subject: 'discover_near' } as const

function ExperiencesHomepageDiscoverNear() {
  const intl = useIntl()
  const data = useExperiencesHomepageDiscoverNearData()

  if (!data) {
    return null
  }

  return (
    <ExperiencesHomepageBrowseTileCarousel
      title={intl.formatMessage(messages.sectionTitle, {
        placeName: data.placeName,
        i: (chunks: ReactNode) => <i key="italic">{chunks}</i>,
      })}
      actionLabel={!data.fetching
        ? intl.formatMessage(messages.viewOffers, { count: data.totalOfferCount })
        : undefined}
      actionUrl={data.searchUrl}
      tiles={data.destinations.map((destination) => ({
        key: destination.key,
        title: destination.title,
        offerCount: destination.offerCount,
        image: destination.image,
        to: destination.to,
      }))}
      isLoading={data.fetching}
      tracking={DISCOVER_NEAR_TRACKING}
    />
  )
}

export default ExperiencesHomepageDiscoverNear
